// Shared phone number helpers: one rule (the one the profile landline field already uses), so every screen checks numbers the same way.

export const PHONE_MIN_DIGITS = 10;
export const PHONE_MAX_DIGITS = 12;

// Error texts already used for the profile's phone number field.
export const PHONE_TOO_SHORT_MESSAGE = "Phone number is too short";
export const PHONE_TOO_LONG_MESSAGE = "Phone number is too long";
export const PHONE_INVALID_MESSAGE = "Invalid phone number";

// Rule 1: anything that is not a digit or "+" is stripped.
export const cleanPhoneNumber = (value?: string | null): string =>
  (value ?? "").replace(/[^\d+]/g, "");

// Rule 2: after removing "+", the number must be 10 to 12 digits.
// Rule 3: an empty value (nothing typed) is allowed here, because the check only runs when a value exists.
// Returns an error message, or "" when the value is fine (or empty).
export function validatePhoneNumber(value?: string | null): string {
  const cleaned = cleanPhoneNumber(value);
  const digits = cleaned.replace(/\+/g, "");
  if (cleaned === "") return "";
  // Only "+" signs and no digits is not an empty value: it is invalid
  if (digits === "") return PHONE_INVALID_MESSAGE;
  if (digits.length < PHONE_MIN_DIGITS) return PHONE_TOO_SHORT_MESSAGE;
  if (digits.length > PHONE_MAX_DIGITS) return PHONE_TOO_LONG_MESSAGE;
  return "";
}

export const isValidPhoneNumber = (value?: string | null): boolean =>
  cleanPhoneNumber(value).replace(/\+/g, "") !== "" && validatePhoneNumber(value) === "";

// For display only: shows the number as entered (nothing added or removed) with a space before the last 6 digits, e.g. 07700 900123 or +447700 900123.
export function formatPhoneNumber(value?: string | null): string {
  const cleaned = cleanPhoneNumber(value);
  if (cleaned.replace(/\+/g, "").length <= 6) return cleaned;
  return `${cleaned.slice(0, -6)} ${cleaned.slice(-6)}`;
}
